import React from 'react'
import Button from '../../../../../components/common/Button/index.jsx';
import { BILLING } from '../../../../../constants/routes.js';
import { useNavigate } from 'react-router-dom';

const SectionTitle = ({ title, subtitle, company, user }) => {
    const navigate = useNavigate();
    return (
        <h3 className="fs1-25rem c15 w100"> {title}
            <br />
            {
                (!company?.subscription || company?.subscription !== 'Pro') && <>
                    {subtitle === "Unlock Pro" ? (
                        <Button
                            text={<p className='fs0-75rem c1'>{company?.subscription === 'Lite' ? 'Unlock Pro' : 'Upgrade to start'}</p>}
                            onClick={() => {
                                const userRole = user?.role?.toLowerCase();
                                const servicedRole = company?.servicedBy?.role?.toLowerCase();
                                const companyId = company?._id;
                                const isSpecialRole = ['advisor', 'investor'].includes(userRole) || ['advisor', 'investor'].includes(servicedRole) || user?.['createdBy']?.['role']?.toLowerCase() == 'investor' || user?.['createdBy']?.['role']?.toLowerCase() == 'advisor';
                                if (isSpecialRole) {
                                    navigate(`/billing/${companyId}/pro/${servicedRole}`);
                                } else {
                                    navigate(BILLING.replace(':id', companyId));
                                }
                            }}
                            btnType="warning"
                            style={{ padding: '0.5rem 1.5rem' }}
                            customClassName='mt0-5rem mb1rem'
                        />
                    ) : (
                        <p className='fs1rem c59 tal w100'>{subtitle}</p>
                    )}
                </>
            }
        </h3>
    )
}

export default SectionTitle;